import React, { useEffect, useMemo, useState } from "react";
import TableContainer from "../../components/Common/TableContainer";
import Breadcrumb from "../../components/Common/Breadcrumb";
import { Card, CardBody, Button, Container } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { formatDate, getRecords } from "../../services/api.service";
import { imageURL } from "../../services/api.service";
import moment from "moment";

const breadcrumbItems = [];

const SparePartIssuesList = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [exportData, setExportData] = useState([]);

  useEffect(() => {
    const projectId = JSON.parse(localStorage.getItem("projectID"));
    getData(projectId);
  }, [searchKeyword, page, pageSize]);

  const getData = async (Id) => {
    try {
      const payload = {
        modelName: "spare_part_issues",
        schema: "public",

        include: [
          {
            model: "spare_part_requests",
            as: "request",
          },
          {
            model: "user_masters",
            as: "issued_by_user",
          },
        ],
      };

      const responseData = await getRecords(payload, "/getRecords");

      // Assign an `index` property starting from 1
      responseData?.data?.forEach((element, index) => {
        element.index = index + 1;
      });
      setTotalCount(responseData.count);

      const sortedData = responseData?.data?.sort((a, b) => b.index - a.index);
      setData(sortedData);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClickAdd = () => {
    navigate("/spare-part-issues-create");
  };

  const handleEditClick = (id) => {
    navigate(`/spare-part-issues-create/${id}`);
  };
  const handleViewClick = (id) => {
    navigate(`/spare-part-issues-view/${id}`);
  };

  const getSearchInputData = (inputValue) => {
    setSearchKeyword(inputValue);
  };

  const nextToPages = () => {
    setPage(page + 1);
  };

  const previousToPages = () => {
    setPage(page - 1);
  };

  const handlePageSizeChange = (data) => {
    setPageSize(data);
    const newTotalPages = Math.ceil(totalCount / data);
    if (page >= newTotalPages) {
      setPage(0);
    }
  };

  const lastToPages = () => {
    setPage(Math.ceil(totalCount / pageSize) - 1);
  };

  const previousFirstToPages = () => {
    setPage(0);
  };

  const columns = useMemo(
    () => [
      {
        Header: "SR.NO",
        accessor: "index",
        accessor: (row) => page * pageSize + row.index,
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "50px" }}>{value}</div>,
      },

      {
        Header: "SPARE PART REQUEST NO",
        accessor: (row) =>
          row?.request && row?.request
            ? row?.request?.spare_part_request_no
            : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },
      {
        Header: "ISSUE QTY",
        accessor: (row) =>
          row?.issue_qty && row?.issue_qty ? row?.issue_qty : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },
      {
        Header: "ISSUED BY",
        accessor: (row) =>
          row?.issued_by_user && row?.issued_by_user?.first_name
            ? row?.issued_by_user?.first_name +
              " " +
              row?.issued_by_user?.last_name
            : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },
      {
        Header: "ISSUED AT",
        accessor: (row) =>
          row?.issued_at && row?.issued_at ? formatDate(row?.issued_at) : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },

      {
        Header: "STATUS",
        accessor: "is_active",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => (
          <div style={{ width: "100px" }}>
            {value === false || value === 0 ? (
              <span className="badge bg-danger-subtle text-danger text-uppercase">
                In-active
              </span>
            ) : (
              <span className="badge bg-success-subtle text-success text-uppercase">
                Active
              </span>
            )}
          </div>
        ),
      },
      {
        Header: "ACTION",
        accessor: "actions",
        disableFilters: true,
        filterable: false,
        Cell: ({ row }) => (
          <div style={{ width: "150px", display: "flex" }}>
            <div
              onClick={() => {
                handleEditClick(row.original.id);
              }}
            >
              <Link className="me-3 text-primary">
                <i className="mdi mdi-pencil font-size-18"></i>
              </Link>
            </div>

            <div
              onClick={() => {
                handleViewClick(row.original.id);
              }}
            >
              <Link className="me-3 text-primary">
                <i className="mdi mdi-eye font-size-18"></i>
              </Link>
            </div>
          </div>
        ),
      },
    ],
    [page, pageSize]
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <Breadcrumb
              title="Spare Part Issues List"
              breadcrumbItems={breadcrumbItems}
            />
            <Button
              color="primary"
              className="waves-effect waves-light me-1"
              onClick={handleClickAdd}
              style={{ marginLeft: "auto", background: "#006eb9" }}
            >
              Spare Part issues
            </Button>
          </div>

          <Card>
            <CardBody>
              <TableContainer
                columns={columns || []}
                data={data || []}
                isPagination={false}
                // isGlobalFilter={false}
                iscustomPageSize={false}
                isBordered={false}
                customPageSize={10}
                isLoading={isLoading}
                onSearchInputData={getSearchInputData}
                pageIndexProp={page}
                onPageSizeChange={handlePageSizeChange}
                nextToPage={nextToPages}
                lastToPage={lastToPages}
                previousToPage={previousToPages}
                previousFirstToPage={previousFirstToPages}
                totalCount={totalCount}
                exportData={exportData}
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default SparePartIssuesList;
